<div class="p-3 container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card-body">
        <div class="flex items-center justify-between w-full">
          <div
            class="flex flex-nowrap items-center gap-1 bg-slate-200 p-1 rounded-xl border border-slate-500 shadow-sm overflow-x-auto">
            <button *ngFor="let tab of proposalStatusTabs"
              class="flex items-center justify-start gap-2 px-2.5 py-2.5 rounded-xl text-xs font-bold transition-all duration-200 whitespace-nowrap min-w-fit outline-none"
              [ngClass]="activeStatusTabIndex.status === tab.status 
              ? 'bg-slate-800 text-white shadow-md ring-1 ring-slate-300' 
              : 'text-slate-700 hover:text-white hover:bg-slate-600/70'" (click)="onProposalStatusTabChange(tab)">

              <span class="w-2 h-4 rounded-2xl" [ngClass]="{
                'bg-gray-600': tab.status === 'form',
                'bg-blue-700': tab.status === 'initiated',
                'bg-amber-700': tab.status === 'in_review',
                'bg-emerald-700': tab.status === 'approved',
                'bg-slate-700': tab.status === 'short_close',
                'bg-red-700': tab.status === 'rejected'
              }">
              </span>

              {{ tab.label }}
            </button>
          </div>
        </div>

        <!-- Tab Content -->
        <div class="tab-content" [class.active]="true">

          <!-- New Proposal Tab - Show Form -->
          <div *ngIf="activeStatusTabIndex.tab === 0" class="card proposal-card mt-3 shadow-sm border-0">
            <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Create New Proposal</h5>
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-warning px-4 py-2" (click)="saveDraft()">Save Draft</button>
                <button type="button" class="btn btn-success px-4 py-2" (click)="openDialog()"
                  *ngIf="proposalForm.valid"> Submit </button>
              </div>
            </div>

            <div class="card-body">
              <div *ngIf="draftProposals && draftProposals.length > 0" class="mb-3">
                <div class="alert alert-info" role="alert">
                  <div class="collapsible-section">
                    <div (click)="isSectionOpen.draftProposals = !isSectionOpen.draftProposals">

                      <i class="pi pi-info-circle me-1"></i>
                      <span>
                        <b>Draft Proposals Found:</b> Select a draft below to continue editing, or fill in the form to
                        create a new proposal.
                      </span>
                      <i class="pi ms-2"
                        [ngClass]="isSectionOpen.draftProposals ? 'pi-chevron-down' : 'pi-chevron-right'"></i>

                    </div>
                    <div class="collapsible-body" *ngIf="isSectionOpen.draftProposals">
                      <app-data-table [data]="draftProposals" [title]="'Draft Proposals'"
                        [url]="'/revenue/save-draft/proposal/'" [isEditable]="true" [showAddButton]="false"
                        (editEventRow)="populateDraftProposal($event) ; isSectionOpen.draftProposals =false "
                        [columns]="draftProposalColumns">
                      </app-data-table>
                    </div>
                  </div>
                </div>
              </div>
              <form [formGroup]="proposalForm" class="space-y-4" autocomplete="off">
                <!-- Header Section - Proposal Name and Scheme -->
                <div
                  class="bg-amber-100/70 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div
                    class="flex items-center justify-between p-4 bg-gray-100/90 text-gray-700 border-b font-medium text-lg">
                    <h3 class="text-lg font-semibold text-slate-800 flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-file"></i>
                      </span>
                      Create New Proposal
                    </h3>
                  </div>
                  <div class="p-6 space-y-4 animate-fade-in">
                    <div class="flex items-center gap-4">
                      <label for="proposalName" class="text-sm font-medium text-slate-700 mb-0" style="width:30%">
                        Proposal Name <span class="text-red-500">*</span>
                      </label>
                      <div style="width:65%">
                        <input pInputText id="proposalName" formControlName="proposalName" autocomplete="off"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                        <div
                          *ngIf="proposalForm.get('proposalName')?.invalid && proposalForm.get('proposalName')?.touched"
                          class="text-red-500 text-xs mt-1">
                          Proposal Name is required
                        </div>
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="scheme" class="text-sm font-medium text-slate-700 mb-0" style="width:30%">
                        Scheme <span class="text-red-500">*</span>
                      </label>
                      <div style="width:65%">
                        <p-dropdown inputId="scheme" formControlName="scheme" [options]="schemes" [filter]="true"
                          filterBy="name" optionLabel="name" optionValue="id" [readonly]="true" placeholder="Scheme"
                          class="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-500 [&_.p-dropdown]:rounded"></p-dropdown>
                        <div *ngIf="proposalForm.get('scheme')?.invalid && proposalForm.get('scheme')?.touched"
                          class="text-red-500 text-xs mt-1">
                          Scheme selection is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Basic Information Section -->
                <div
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('basicInfo')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-lime-100 text-lime-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-info-circle"></i>
                      </span>
                      Basic Information
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.basicInfo ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.basicInfo"
                    class="px-6 pt-4 pb-6 border-t border-slate-100 animate-fade-in space-y-4">
                    <div class="flex items-center gap-4">
                      <label for="platform" class="text-sm font-medium text-slate-700 mb-0 w-1/4" style="width:30%">
                        For which Platform
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="platform" formControlName="platform" autocomplete="off"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="tenderMode" class="text-sm font-medium text-slate-700 mb-0 w-1/4" style="width:30%">
                        Mode of Tender
                      </label>
                      <div class="w-3/4">
                        <p-dropdown inputId="tenderMode" [options]="tenderModes" formControlName="tenderMode"
                          optionLabel="label" optionValue="value" appendTo="body" placeholder="Select Mode"
                          class="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-500 [&_.p-dropdown]:rounded"></p-dropdown>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Equipment & System Section -->
                <div
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('equipment')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-cog"></i>
                      </span>
                      Equipment & System
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.equipment ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.equipment"
                    class="px-6 pt-4 pb-6 border-t border-slate-100 animate-fade-in space-y-4 overflow-visible">
                    <div class="flex items-center gap-4">
                      <label for="equipment" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        Equipment <span class="text-red-500">*</span>
                      </label>
                      <div class="w-3/4 relative z-50 overflow-visible">
                        <p-dropdown formControlName="equipment" [options]="filteredEquipment"
                          placeholder="Select Equipment" optionLabel="name" optionValue="id" [filter]="true"
                          filterBy="name" appendTo="body" emptyFilterMessage=" "
                          class="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-500 [&_.p-dropdown]:rounded">
                          <ng-template pTemplate="emptyfilter">
                            <div class="flex flex-column align-items-center gap-2 p-2">
                              <span class="text-sm text-gray-500">No results found</span>
                              <button type="button" class="p-button p-button-sm p-button-outlined p-button-success"
                                (click)="showAddEquipmentDialog = true"
                                style="font-size: 0.85rem; padding: 0.35rem 0.75rem;">
                                <i class="pi pi-plus mr-1" style="font-size: 0.8rem;"></i> Add New Equipment
                              </button>
                            </div>
                          </ng-template>
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="system" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        System <span class="text-red-500">*</span>
                      </label>
                      <div class="w-3/4 relative z-50 overflow-visible">
                        <p-dropdown formControlName="system" [options]="filteredSystem" placeholder="Select System"
                          optionLabel="name" optionValue="id" [filter]="true" filterBy="name" appendTo="body"
                          emptyFilterMessage=" "
                          class="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-500 [&_.p-dropdown]:rounded">
                          <ng-template pTemplate="emptyfilter">
                            <div class="flex flex-column align-items-center gap-2 p-2">
                              <span class="text-sm text-gray-500">No results found</span>
                              <button type="button" class="p-button p-button-sm p-button-outlined p-button-success"
                                (click)="showAddSystemDialog = true"
                                style="font-size: 0.85rem; padding: 0.35rem 0.75rem;">
                                <i class="pi pi-plus mr-1" style="font-size: 0.8rem;"></i> Add New System
                              </button>
                            </div>
                          </ng-template>
                        </p-dropdown>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Quantity Details Section -->
                <div
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('quantity')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-orange-100 text-orange-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-sliders-h"></i>
                      </span>
                      Quantity Details
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.quantity ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.quantity"
                    class="px-6 pt-4 pb-6 border-t border-slate-100 animate-fade-in space-y-4">
                    <div class="flex items-center gap-4">
                      <label for="qtyReqd" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        Total Quantity Required <span class="text-red-500">*</span>
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="qtyReqd" formControlName="qtyReqd" (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="qtyPrototype" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        Quantity Prototype <span class="text-red-500">*</span>
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="qtyPrototype" formControlName="qtyPrototype"
                          (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="qtyBulk" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        Quantity Bulk (MOQ) <span class="text-red-500">*</span>
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="qtyBulk" formControlName="qtyBulk" (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Cost Details Section -->
                <div
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('cost')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-pink-100 text-pink-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-dollar"></i>
                      </span>
                      Cost Details
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.cost ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.cost"
                    class="px-6 pt-4 pb-6 border-t border-slate-100 animate-fade-in space-y-4">

                    <div class="flex items-center gap-4">
                      <label for="estimatedDevelopmentCost" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        Estimated Total Cost in(INR)
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="estimatedDevelopmentCost" formControlName="estimatedDevelopmentCost"
                          autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="estimatedUnitCost" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        Estimated Unit Cost in(INR)
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="estimatedUnitCost" formControlName="estimatedUnitCost" autocomplete="off"
                          (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="llp" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        Last Purchase Price in(INR)
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="llp" formControlName="llp" autocomplete="off"
                          (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="poev" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        POEV Cost in(INR)
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="poev" formControlName="poev" autocomplete="off"
                          (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="consignee" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        Consignee
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="consignee" formControlName="consignee" autocomplete="off"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Detailed Information Section -->
                <div
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('detailed')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-align-left"></i>
                      </span>
                      Detailed Information
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.detailed ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.detailed" class="p-6 border-t border-slate-100 animate-fade-in space-y-6">
                    <div class="border border-slate-500 rounded-lg">
                      <label class="text-base p-2 text-blue-600 font-semibold mb-0 ">
                        Brief Description / Technical Details <span class="text-green-500">*</span>
                      </label>
                      <div class=" ">
                        <editor [init]="init" id="technologyInsertion" formControlName="technologyInsertion"></editor>
                      </div>
                    </div>
                    <div class="border border-slate-500 rounded-lg">
                      <label for="justificationText" class="text-base p-2 text-blue-600 font-semibold mb-0 ">
                        Justification for Mode of Tender
                      </label>
                      <div class=" ">
                        <editor [init]="init" id="justificationText" formControlName="justificationText"></editor>
                      </div>
                    </div>
                    <div class="border border-slate-500 rounded-lg">
                      <label for="justificationText" class="text-base p-2 text-blue-600 font-semibold mb-0 ">
                        Any export potential of the proposed item
                      </label>
                      <div class=" ">
                        <editor [init]="init" formControlName="exportPotential"></editor>
                      </div>

                    </div>
                  </div>
                </div>

                <!-- Document Uploads Section (same structure as idex-from; SOTR and SOC mandatory) -->
                <div
                  class="bg-amber-50 border-2 border-gray-300 mb-3 rounded transition-all duration-200 hover:shadow-md">
                  <div (click)="isSectionOpen.documentUploads = !isSectionOpen.documentUploads"
                    class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-paperclip"></i>
                      </span>
                      Document Uploads
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.documentUploads ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.documentUploads"
                    class="p-3 space-y-4 border-t border-slate-100 animate-fade-in">
                    <app-upload-document #uploadDoc [isEditable]="true"
                      [dmsFiles]="selectedDraftProposal?.dms_files || files || []" [isSaveVied]="true"
                      (uploadData)="onDocumentUpload($event)">
                    </app-upload-document>
                  </div>
                </div>
              </form>
            </div>
          </div>


          <!-- On going Proposal Tab - Show Table -->
          <div *ngIf="activeStatusTabIndex.tab === 1 " class="card mt-3 shadow-sm border-0">
            <div class="card-header d-flex justify-content-between bg-primary text-white">
              <!-- <div class="search-input d-flex align-items-center">
                <i class="pi pi-search me-2"></i>
                <input type="text" class="form-control border-0" placeholder="Search ..."
                (input)="searchProposals($event)" />
              </div> -->
              <h4 class="card-title mb-0">{{activeStatusTabIndex.label}}</h4>
              <div class="filter-section d-flex g-2 align-items-center">
                <div class="d-flex mx-3">
                  <!-- <p-button *ngIf="activeStatusTabIndex.status === 'initiated'" 
                    (click)="approveAPSO()" class="btn btn-success me-2 p-0">
                  </p-button> -->
                  <p-button label="Clear Filters" icon="pi pi-filter-slash" severity="success"
                    (click)="clear(dt, searchInput)" class="clear-filters-btn">
                  </p-button>
                </div>
                <div class="filter-right">
                  <span class=" p-input-icon-left ">
                    <i class="pi pi-search"></i>
                    <input #searchInput pInputText type="text" [(ngModel)]="searchProposalQuery"
                      (keyup.enter)="searchProposals(searchProposalQuery)" placeholder="Search all records..."
                      class="search-field" />
                  </span>
                </div>
              </div>
            </div>
            <div class="card-body">

              <div class="table-responsive p-3">
                <p-table #dt [value]="proposalData" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[5, 10, 20, 50]" [paginator]="true" [lazy]="lazy" [totalRecords]="totalCount"
                  (onPage)="onPageChange($event)"
                  [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'"
                  [scrollable]="true" [(selection)]="selectedProposals" scrollDirection="both" [resizableColumns]="true"
                  [reorderableColumns]="true"
                  [globalFilterFields]="['name','description','proposal_status','created_by.first_name','created_by.last_name']"
                  dataKey="id" class="p-datatable-sm complex-proposal-table">

                  <ng-template pTemplate="header">
                    <tr>
                      <ng-container *ngFor="let column of tableColumns">
                        <th (click)="lazy=false" [pSortableColumn]=" column.field" pResizableColumn
                          class="sortable-column">
                          <!-- Column Header -->
                          <ng-container [ngSwitch]="column.field">
                            <ng-container *ngSwitchCase="'checkbox'">
                              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                              <!-- <p-sortIcon styleClass="custom-sort-icon mx-2 text-white bg-amber-100" [field]="column.field"></p-sortIcon> -->
                              <span>{{ column.header }}</span>
                            </ng-container>
                          </ng-container>

                          <!-- Column Filter -->
                          <p-columnFilter class="text-gray-600" *ngIf="column.filter" [type]="column.filterType"
                            [field]="column.field" display="menu" [showMatchModes]="true" [showOperator]="false"
                            [showAddButton]="false"></p-columnFilter>
                        </th>
                      </ng-container>
                    </tr>
                  </ng-template>

                  <!-- 🧩 Table Body -->
                  <ng-template pTemplate="body" let-proposal>
                    <tr [ngClass]="{ 'table-row-hover': true }">
                      <ng-container *ngFor="let column of tableColumns">
                        <td class="align-middle text-nowrap">
                          <ng-container [ngSwitch]="column.field">

                            <!-- ✅ Checkbox -->
                            <ng-container *ngSwitchCase="'checkbox'">
                              <p-tableCheckbox [value]="proposal" selectionMode="multiple"></p-tableCheckbox>
                            </ng-container>

                            <!-- ✅ Name -->
                            <ng-container *ngSwitchCase="'name'">
                              <span class="fw-semibold text-primary pointer" pTooltip="{{ proposal.name }}"
                                (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                {{ proposal.name }}
                              </span>
                            </ng-container>

                            <!-- ✅ Description -->
                            <ng-container *ngSwitchCase="'description'">
                              <span class="text-muted text-truncate d-inline-block" style="max-width: 250px;"
                                [pTooltip]="proposal.description">
                                {{ proposal.description }}
                              </span>
                            </ng-container>

                            <!-- ✅ Steps -->
                            <ng-container *ngSwitchCase="'steps'">
                              <span class="badge bg-info text-dark">
                                {{ proposal.step_summary?.completed_steps || 0 }}/{{ proposal.step_summary?.total_steps
                                || 0 }}
                              </span>
                            </ng-container>

                            <!-- ✅ Progress -->
                            <ng-container *ngSwitchCase="'progress'">
                              <div class="progress" style="height: 8px;">
                                <div class="progress-bar bg-success"
                                  [style.width.%]="proposal.step_summary?.completed_percentage || 0"></div>
                              </div>
                              <small class="text-muted">
                                {{ proposal.step_summary?.completed_percentage || 0 }}%
                              </small>
                            </ng-container>

                            <!-- ✅ Created By -->
                            <ng-container *ngSwitchCase="'created_by'">
                              <i class="pi pi-user text-secondary me-1"></i>
                              {{ proposal.created_by?.first_name }} {{ proposal.created_by?.last_name }}
                            </ng-container>

                            <!-- ✅ Directorate -->
                            <ng-container *ngSwitchCase="'directorate'">
                              <i class="pi pi-building text-secondary me-1"></i>
                              {{ proposal.created_by?.unit?.name }}
                            </ng-container>

                            <!-- ✅ Status -->
                            <ng-container *ngSwitchCase="'proposal_status'">
                              <span class="badge rounded-pill px-3 py-1"
                                [ngClass]="getStatusBadgeClass(proposal.proposal_status)">
                                {{ proposal.proposal_status | titlecase }}
                              </span>
                            </ng-container>

                            <!-- ✅ Actions -->
                            <ng-container *ngSwitchCase="'actions'">
                              <button pButton type="button" icon="pi pi-ellipsis-v"
                                class="p-button-rounded p-button-text action-btn" (click)="op.toggle($event)"></button>

                              <p-overlayPanel #op>
                                <div class="list-group small">
                                  <a class="list-group-item list-group-item-action pointer"
                                    (click)="updateProposal(proposal)">
                                    Edit
                                  </a>
                                  <a class="list-group-item list-group-item-action pointer text-danger"
                                    (click)="deleteProposal(proposal)">
                                    Delete
                                  </a>
                                  <a class="list-group-item list-group-item-action pointer"
                                    (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                    Go to Steps
                                  </a>
                                </div>
                              </p-overlayPanel>
                            </ng-container>

                            <!-- ✅ Default -->
                            <ng-container *ngSwitchDefault>
                              {{ getFieldValue(proposal, column.field) || '-' }}
                            </ng-container>

                          </ng-container>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-template>

                  <!-- 📉 Empty Message -->
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="tableColumns.length" class="text-center text-muted py-3">
                        <i class="pi pi-info-circle me-2"></i> No proposals found.
                      </td>
                    </tr>
                  </ng-template>

                </p-table>
              </div>
            </div>
          </div>
        </div>
        <!-- No Proposals -->
        <ng-template #noData>
          <div class="alert alert-info">No proposals available for this phase.</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<ng-template #proposalCardTemplate let-proposal>
  <div class="card scheme-card h-100 p-3">
    <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
      <p-tag severity="info" [value]="proposal?.scheme?.name" class="mb-2 mb-sm-0"></p-tag>
      <div class="d-flex gap-3">
        <span (click)="deleteProposal(proposal)" class="btn btn-light" pTooltip="Delete Proposal" tooltipPosition="top"
          *ngIf="
            ('/master/proposal' | hasPermission : 'Delete') ||
            proposal.can_edit == true
          "><i class="pi pi-trash delete-red"></i></span>
        <span (click)="updateProposal(proposal)" class="btn btn-light" pTooltip="Edit Proposal" tooltipPosition="top"
          *ngIf="
            ('/master/proposal' | hasPermission : 'Edit') ||
            proposal.can_edit == true
          "><i class="pi pi-pencil"></i></span>
        <span (click)="navigateToSchemeTransaction(proposal, activePhaseId)" class="btn btn-light"
          pTooltip="Go to Steps" tooltipPosition="top" *ngIf="'/master/proposal' | hasPermission : 'View'"><i
            class="pi pi-arrow-right"></i></span>
      </div>
    </div>

    <div class="ms-1">
      <h5 class="fw-bold mb-1">{{ proposal?.name }}</h5>
      <p class="text-muted-card small mb-3 description-truncate" [pTooltip]="proposal.description"
        tooltipPosition="top">
        {{ proposal.description }}
      </p>
    </div>

    <div class="mt-auto">
      <div class="d-flex justify-content-between small text-muted-card ms-1 mb-1">
        <span>Step {{ proposal.step_summary.completed_steps || 0 }}/{{
          proposal.step_summary.total_steps || 0
          }}</span>
        <span>{{ proposal.step_summary.completed_percentage }}% Complete</span>
      </div>
      <div class="progress ms-1 mb-3">
        <div class="progress-bar bg-primary" role="progressbar"
          [style.width.%]="proposal.step_summary.completed_percentage" aria-valuemin="0" aria-valuemax="100"></div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="text-muted-card small">
          <i class="bi bi-clock me-1"></i> Created
          {{ proposal.created_on | date : "dd-MM-yyyy" }}
        </div>
        <p-tag [value]="proposal.proposal_status | uppercase" severity="success" rounded></p-tag>
      </div>

      <button class="btn btn-gradient w-100" (click)="navigateToScheme(proposal)">
        View Details
      </button>
    </div>
  </div>
</ng-template>


<ng-container *ngIf="isDeleteProposal">
  <p-dialog header="Delete Proposal" [modal]="true" [(visible)]="isDeleteProposal" [style]="{ width: '30rem' }"
    [maximizable]="true">
    <div class="delete-dialog">
      <span>Are you sure , you want to delete
        {{ selectedProposal.name }} proposal?</span>
      <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="confirmDelete()">
      </p-button>
    </div>
  </p-dialog>
</ng-container>

<ng-container *ngIf="displayDialogN">
  <app-scheme-wise-route-popup [displayDialog]="displayDialogN" (closeDialog)="displayDialogN = false"
    (onSubmit)="onNeedformSubmit($event)"></app-scheme-wise-route-popup>
</ng-container>

<!-- <p-dialog header="Share Proposal" [(visible)]="displayDialogN" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '65vw'}" appendTo="body" contentStyle="overflow: visible">

  <div class="p-fluid">
    <div class=" mb-4 mt-3">
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-4 bg-primary text-white d-flex align-items-center justify-content-start p-3">Share With:</div>
        <div class="col-8 d-flex align-items-center ps-5">
          <div class="col-6 d-flex align-items-center gap-2">
            <p-radioButton name="shareType" value="internal" [(ngModel)]="shareType" class="d-block"></p-radioButton>
            <span>Internal</span>
          </div>
          <div class="col-6 d-flex align-items-center gap-2">
            <p-radioButton name="shareType" value="external" [(ngModel)]="shareType" class="d-block"></p-radioButton>
            <span>External</span>
          </div>
        </div>
      </div>
    </div>

    <div class=" mb-4" *ngIf="shareType">
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-4 bg-primary text-white d-flex align-items-center justify-content-start p-3">Permission Type:</div>
        <div class="col-8 d-flex align-items-center ps-5">
          <div class="col-4 d-flex align-items-center gap-2">
            <p-radioButton name="permission" value="edit" [(ngModel)]="permissionType" class="d-block"></p-radioButton>
            <span>Edit</span>
          </div>
          <div class="col-4 d-flex align-items-center gap-2">
            <p-radioButton name="permission" value="view" [(ngModel)]="permissionType" class="d-block"></p-radioButton>
            <span>View</span>
          </div>
          <div class="col-4 d-flex align-items-center gap-2">
            <p-radioButton name="permission" value="comment" [(ngModel)]="permissionType" class="d-block"></p-radioButton>
            <span>Comment</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="shareType === 'internal' && permissionType" class="row mb-4">
      <div class="col-12">
      <div class="row">
        <div class="col-12">
        <div class="row">
          <div class="col-4 bg-primary text-white d-flex align-items-center">
          <b class="mb-2 d-block">
            {{ permissionType === 'edit' ? 'Select User' : 'Select Users' }}
          </b>
          </div>
          <div class="col-8">
          <p-dropdown *ngIf="permissionType === 'edit'" id="userSelect" [options]="userList" filter="true"
            filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" [(ngModel)]="selectedUser"
            placeholder="Choose a user" appendTo="body" class="w-100">
          
            <ng-template pTemplate="selectedItem" let-user>
            <div *ngIf="user">
              <small>
              #<strong>{{ user.loginname }}</strong> |
              <strong>{{ user.first_name }} {{ user.last_name }}</strong> 
              </small>
            </div>
            <div *ngIf="!user" class="dropdown-placeholder">
              Choose a user
            </div>
            </ng-template>
          
            <ng-template pTemplate="item" let-user>
            <div class="list-group-item list-group-item-action">
              <small>
                #<strong>{{ user.loginname }}</strong> |
                <strong>{{ user.first_name }} {{ user.last_name }}</strong> |	 <strong>{{ user.hrcdf_designation }}</strong>
              </small>
            </div>
            </ng-template>
          
          </p-dropdown>
    
  
          
          <p-multiSelect *ngIf="permissionType !== 'edit'" 
            [options]="userList" 
            optionLabel="loginname"
            filter="true"
            filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name"
            [(ngModel)]="selectedUsers" 
            placeholder="Choose users" 
            appendTo="body" 
            class="w-100">
            <ng-template pTemplate="item" let-user>
            <div class="list-group-item list-group-item-action">
              <small>
                #<strong>{{ user.loginname }}</strong> |
                <strong>{{ user.first_name }} {{ user.last_name }}</strong> |	 <strong>{{ user.hrcdf_designation }}</strong>
              </small>
            </div>
            </ng-template>
          </p-multiSelect>
          </div>
        </div>
        </div>
      </div>
  
      <div class="row mt-3">
        <div class="col-4 bg-primary text-white d-flex align-items-center">
        <b class="mb-2 d-block">Comment (optional)</b>
        </div>
        <div class="col-8">
        <textarea id="internalComment" class="form-control w-100" rows="3" [(ngModel)]="internalComment"
          placeholder="Enter your comment here..."></textarea>
        </div>
      </div>
      </div>
    </div>

    <div *ngIf="shareType === 'external' && permissionType" class="row mb-4">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="row mb-3">
              <div class="col-4 bg-primary text-white d-flex align-items-center">
                <b class="mb-2 d-block">
                  {{ permissionType === 'edit' ? 'Select Unit' : 'Select Units' }}
                </b>
              </div>
              <div class="col-8">
                <p-dropdown *ngIf="permissionType === 'edit'" 
                  id="unitSelect" 
                  [options]="unitList" 
                  optionLabel="name" 
                  [(ngModel)]="selectedUnit"
                  placeholder="Choose a unit" 
                  appendTo="body" 
                  class="w-100">
                </p-dropdown>
                
                <p-multiSelect *ngIf="permissionType !== 'edit'" 
                  [options]="unitList" 
                  optionLabel="name" 
                  [(ngModel)]="selectedUnits"
                  placeholder="Choose units" 
                  appendTo="body" 
                  class="w-100">
                </p-multiSelect>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4 bg-primary text-white d-flex align-items-center">
            <b class="mb-2 d-block">Comment (optional)</b>
          </div>
          <div class="col-8">
            <textarea id="externalComment" class="form-control w-100" rows="3" [(ngModel)]="externalComment"
              placeholder="Enter your comment here..."></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button (click)="onNeedformSubmit()"  [ngClass]="{'opacity-80 cursor-not-allowed': isLoading}"
            class="fetch-data-btn p-button p-button-sm p-button-primary"
            [disabled]="!isFormValid() || isLoading"> 
      {{isLoading ? 'Submitting...' : 'Submit'}}
    </button>
  </ng-template>
</p-dialog> -->

<!-- Add New Equipment Dialog -->
<p-dialog header="Add New Equipment" [(visible)]="showAddEquipmentDialog" [modal]="true" [style]="{ width: '28rem' }"
  [draggable]="false" [resizable]="false">
  <div class="p-fluid">
    <div class="mb-3">
      <label for="newEquipmentName" class="font-medium text-sm mb-2 d-block">Equipment Name <span
          class="text-red-500">*</span></label>
      <input pInputText id="newEquipmentName" [(ngModel)]="newEquipmentName" placeholder="Enter equipment name"
        class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="p-button p-button-sm p-button-text"
        (click)="showAddEquipmentDialog = false; newEquipmentName = ''">Cancel</button>
      <button type="button" class="p-button p-button-sm p-button-success" [disabled]="!newEquipmentName?.trim()"
        (click)="addNewEquipment()">
        <i class="pi pi-check mr-1"></i> Save
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Add New System Dialog -->
<p-dialog header="Add New System" [(visible)]="showAddSystemDialog" [modal]="true" [style]="{ width: '28rem' }"
  [draggable]="false" [resizable]="false">
  <div class="p-fluid">
    <div class="mb-3">
      <label for="newSystemName" class="font-medium text-sm mb-2 d-block">System Name <span
          class="text-red-500">*</span></label>
      <input pInputText id="newSystemName" [(ngModel)]="newSystemName" placeholder="Enter system name"
        class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="p-button p-button-sm p-button-text"
        (click)="showAddSystemDialog = false; newSystemName = ''">Cancel</button>
      <button type="button" class="p-button p-button-sm p-button-success" [disabled]="!newSystemName?.trim()"
        (click)="addNewSystem()">
        <i class="pi pi-check mr-1"></i> Save
      </button>
    </div>
  </ng-template>
</p-dialog>